import React, { useEffect, useRef } from "react";
import shawn3 from "../../images/shawn3.png";
import Typed from "typed.js";
import { Link } from "react-router-dom";
import { MyGlobalContext } from "../../Context";

const EmptyCart = () => {
  const { toggleRunPath } = MyGlobalContext();
  const RefSpanType = useRef(null);
  const HoldType = useRef(null);

  useEffect(() => {
    const typeOptions = {
      strings: [
        "currently, order is empty.",
        "nothing to pay.",
        "back to home and order something first.",
        "Don't stay long, to see my ugly picture :)",
        "please back home.",
      ],
      typeSpeed: 100,
      backSpeed: 100,
      loop: true,
    };
    HoldType.current = new Typed(RefSpanType.current, typeOptions);
    return () => HoldType.current.destroy();
  }, []);
  return (
    <div className="empty-padding">
      <div data-aos="zoom-in-right" className="h1-height">
        <h1 className="h1-order">Cart Status:</h1>
        <div className="underlines"></div>
        <h3 className="span-auto-type">
          <span ref={RefSpanType}></span>
        </h3>
      </div>
      <img
        data-aos="zoom-in-up"
        src={shawn3}
        alt="you don't have any order.."
        className="cart-my-image"
      />
      <div className="btn-center-cart">
        <button>
          <Link onClick={toggleRunPath} to="/" className="Link-cart">
            Back to Home
          </Link>
        </button>
      </div>
    </div>
  );
};

export default EmptyCart;
